import { PoiOpeningHours, poiOpeningHours } from './PoiOpeningHours';
import { PoiSecurityZoneItems, poiSecurityZoneItems } from './PoiSecurityZone';

export enum PoiFilterOption {
	Location = 'Location',
	OpeningHours = 'Opening Hours',
	SecurityZone = 'Security Zone',
	Types = 'Types',
}

export const poiFilterOptions = Object.values(PoiFilterOption);

export type IPoiFilterType = string | PoiOpeningHours | PoiSecurityZoneItems;

export const mapPoiFilterTypeToFilterItems = (
	filterType: PoiFilterOption,
	poiTypeKeywords: string[],
	locationItems: string[],
) => {
	const map = {
		[PoiFilterOption.Location]: locationItems,
		[PoiFilterOption.OpeningHours]: poiOpeningHours,
		[PoiFilterOption.SecurityZone]: poiSecurityZoneItems,
		[PoiFilterOption.Types]: poiTypeKeywords,
	};
	return map[filterType];
};
